<template>
    <modal :show.sync=show modalClasses="medium-sized-modal" :hide-footer="true">
        <h3 slot="header" class="mb-0 font-weight-500">Sign Consent Form</h3>
    </modal>
</template>
<script>
import Modal from "@/components/Modal"

export default {
    props:{
        sign_form: Boolean
    },
    components: {
        Modal,
    },
    computed: {
        show: {
            get() {
                return this.sign_form;
            },
            set(newVal) {
                this.$emit('update:sign_form', newVal);
            },
        },
    },
}
</script>